import React from 'react';
import YogaClass from './YogaClass';
import './Results.css';

const headers = ['Title', 'Length (in minutes)', 'Mood'];

const Results = ({ classes, randomized }) => {
  // useEffect(() => {
  //   setClassList(classes);
  // }, [classes]);

  // const onRefreshClick = () => {
  //   console.log(refresh);
  //   const newRefresh = refresh + 1;
  //   setRefresh(newRefresh);
  // };

  // const getRandomClasses = (classArr, n) => {
  //   if (classList.length <= n) {
  //     return classList;
  //   } else {
  //     var result = new Array(n),
  //       len = classArr.length,
  //       taken = new Array(len);
  //     if (n > len) n = len;
  //     while (n--) {
  //       var x = Math.floor(Math.random() * len);
  //       result[n] = classArr[x in taken ? taken[x] : x];
  //       taken[x] = --len in taken ? taken[len] : len;
  //     }
  //     return result;
  //   }
  // };

  // const numClasses = 10;
  // const randomClasses = getRandomClasses(classList, numClasses);

  return (
    <div>
      <div className="w-90-l w-100-m w-100-s center pt4">
        <div className="overflow-auto">
          <table className="f7 w-100 mw9 center" cellSpacing="0">
            <thead>
              <tr className="stripe-dark">
                {headers.map((header) => {
                  return (
                    <th className="fw6 tl pa3 bg-white black" key={header}>
                      {header}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="lh-copy">
              {classes.map((c) => (
                <YogaClass c={c} key={c.id} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Results;
